import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.to-string";
import _slicedToArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { dailyTaskDesc, dailyTaskDescCurrency } from "@/api/kamitaku/kamitaku";
export default {
  name: "accountRegistration",
  mixins: [tabulation],
  data: function data() {
    return {
      searchData: {
        tasks: '',
        dimension_kind: "user",
        stat_type: 'complete'
      },
      deviceList: [{
        label: this.$t('newAccountLabel'),
        id: "user"
      }, {
        label: this.$t('newPayAccountLabel'),
        id: "pay_user"
      }],
      totalDynamic: [],
      totalDynamicValue: [],
      Dynamic: [],
      chooseList: [{
        label: this.$t('completeCount'),
        value: "complete"
      }, {
        label: this.$t('receiveCount'),
        value: "receive"
      }]
    };
  },
  created: function created() {},
  watch: {},
  methods: {
    totalDynamicChange: function totalDynamicChange(e) {
      this.searchData.task_id = e.join(",");
    },
    getListnew: function getListnew() {
      var _this = this;

      this.tableData = [];
      this.Dynamic = [];
      this.totalDynamic = [];
      this.totalDynamicValue = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.reqLoading = true;
      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      console.log("searchCurrency", searchCurrency);
      var reqFn = searchCurrency.length ? dailyTaskDescCurrency : dailyTaskDesc;
      reqFn(this.searchData).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          var task_list = res.task_list;

          for (var i in task_list) {
            _this.Dynamic.push({
              label: task_list[i],
              prop: "".concat(i, "_display"),
              value: i.substring(i.indexOf(':') + 1)
            }); // for(let j in data[i]["tasks"]){
            //   this.Dynamic.push(
            //     {
            //       label: j.substring(0, (j.indexOf(':'))),
            //       prop: `${j}_display`,
            //       value:  j.substring(j.indexOf(':')+1)
            //     }
            //   );
            // }
            // break;

          }

          data[_this.$t('total')] = res.total;
          var tableCopyData = "";
          tableCopyData = JSON.parse(JSON.stringify(data));

          for (var m in tableCopyData) {
            tableCopyData[m]["tasksList"] = {};

            for (var n in tableCopyData[m]["tasks"]) {
              tableCopyData[m]["tasksList"]["".concat(n, "_display")] = tableCopyData[m]["tasks"][n]["display"] + '/' + ((tableCopyData[m]["tasks"][n]["display"] / tableCopyData[m]["register_count"] * 100).toFixed(2) + '%');
            }
          }

          console.log("tableCopyData", tableCopyData);

          for (var _i in tableCopyData) {
            _this.tableData.push(_objectSpread(_objectSpread({}, tableCopyData[_i]["tasksList"]), {}, {
              date: _i,
              register_count: tableCopyData[_i]["register_count"]
            }));
          }

          _this.totalDynamic = Object.entries(res.task_list).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                value = _ref2[0],
                label = _ref2[1];

            return {
              label: label,
              value: value
            };
          });
          _this.totalDynamicValue = _this.Dynamic.map(function (item) {
            return item.value;
          });

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('newUserLabel'),
        prop: 'register_count'
      }];
      this.Dynamic.map(function (item) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};